import utils from "../utils/utils";
import deliveryDate from '../components/delivery-date';

export default function checkoutPage() {

    let form = document.getElementsByName('checkout');

    if (form.length) {
        let different_address = document.getElementById('ship-to-different-address-checkbox');

        let billing_inputs_container = document.querySelector('#woocommerce-checkout-billing');
        let shipping_inputs_container = document.getElementById('woocommerce-checkout-shipping');

        let billing_inputs = billing_inputs_container.getElementsByTagName('input');
        let shipping_inputs = shipping_inputs_container.getElementsByTagName('input');
        let billing_selects = billing_inputs_container.getElementsByTagName('select');
        let shipping_selects = shipping_inputs_container.getElementsByTagName('select');

        different_address.addEventListener('change', function () {

            if (this.checked) {
                for (var i = 0; i < shipping_inputs.length; i++) {
                    shipping_inputs[i].value = '';
                    if (shipping_inputs[i].closest('.woocommerce-validated')) {
                        utils.removeClass(shipping_inputs[i].closest('.woocommerce-validated'), 'woocommerce-validated');
                    }
                }

                for (var i = 0; i < shipping_selects.length; i++) {
                    shipping_selects[i].selectedIndex = 0;
                }
            } else {
                for (var i = 0; i < billing_selects.length; i++) {
                    let input_name = billing_selects[i].name;
                    let shipping_name = input_name.replace('billing', 'shipping');
                    let shipping_input = document.querySelector('select[name="' + shipping_name + '"]');
                    if (shipping_input) {
                        shipping_input.value = billing_inputs[i].value;
                    }
                }

                for (var i = 0; i < billing_inputs.length; i++) {
                    let input_name = billing_inputs[i].name;
                    let shipping_name = input_name.replace('billing', 'shipping');
                    let shipping_input = document.querySelector('input[name="' + shipping_name + '"]');
                    if (shipping_input) {
                        shipping_input.value = billing_inputs[i].value;
                    }
                }
            }
        });
    }

    deliveryDate();

}